import React from 'react';

import CustomTh from '../shared/table/CustomTh';
import ListView from '../shared/lists/ListView';
import ProposalItem from './ProposalItem';

const ProposalList = ({
    addItem,
    canAdd,
    data: { items },
    editItem,
    fetchData
}) => {
    const tableHead = (
        <thead className="table-index-head">
            <tr>
                <CustomTh content="Number" />
                <CustomTh content="Total" />
                <CustomTh content="Date" />
                <CustomTh width="80px" />
            </tr>
        </thead>
    );

    const listItems = items && items.map((item) =>
        <ProposalItem
            editItem={() => editItem(item.id)}
            fetchData={fetchData}
            item={item}
            key={item.id}
        />);

    return (
        <ListView
            addItem={addItem}
            canAdd={canAdd}
            itemName="Proposal"
            items={listItems}
            tableHead={tableHead}
        />);
}

export default ProposalList;